import styled, { css } from 'styled-components';
import { StyledCTALink } from './StyledCTALink';

export function styledHeadingLink() {
    return css`
        border-bottom-width: 2px;
    `;
}
export const StyledHeadingLink = styled(StyledCTALink)(styledHeadingLink);
